import { MCO_DOMAIN, MCO_ORDER_PATH, NEXON_ESSENTIAL_DOMAIN, SERVICE_ENV, SERVICE_PROTOCOL } from '@/libs/constant';
import { T } from '@/libs/translation';
import { Icon, Typo } from '@/ui/component/atom';
import { entries, map, pipe, toArray } from '@fxts/core';
import { html, type Html, Page } from 'rune-ts';
import { Layout } from '../../cell';
import klass from './Landing.module.scss';

export interface LandingPageData {}

export class LandingPage extends Page<LandingPageData> {
  protected override template(): Html {
    return html`
      <div>
        ${new Layout({
          view: html` <div class="${klass.page}">
            <div class="${klass.logo}">
              ${new Icon({
                name: 'mco_logo',
                size: 80,
              })}
            </div>
            <div class="${klass.guide}">${new Typo({ text: html.preventEscape(T('landing.guide')) })}</div>
            <div class="${klass.services}">
              ${pipe(
                MCO_DOMAIN,
                entries,
                map(([service_name, domain]) => {
                  return html`
                    <a class="${klass.item} ${service_name}" href="${domain}${MCO_ORDER_PATH[service_name]}">
                      <div data-theme="${service_name}" class="${klass.logo}">
                        ${new Icon({
                          name: 'logo_mini',
                          theme: service_name,
                          size: service_name === 'Ciety' ? 28 : service_name === 'MarppleShop' ? 21 : 15,
                        })}
                      </div>
                      <div class="${klass.text}">
                        ${new Typo({ text: T('common.service_description', { context: service_name }) })}
                        ${new Typo({ text: T('common.service', { context: service_name }) }, { weight: 'bold' })}
                      </div>
                    </a>
                  `;
                }),
                toArray,
              )}
              <a
                class="${klass.item} NexonEssential"
                href="${SERVICE_PROTOCOL}${NEXON_ESSENTIAL_DOMAIN[SERVICE_ENV]}${MCO_ORDER_PATH.NexonEssential}"
              >
                <div data-theme="NexonEssential" class="${klass.logo}">
                  ${new Icon({
                    name: 'ness_logo_mini',
                    theme: 'Marpple',
                    size: 20,
                  })}
                </div>
                <div class="${klass.text}">
                  ${new Typo({ text: T('common.service_description', { context: 'NexonEssential' }) })}
                  ${new Typo({ text: T('common.service', { context: 'NexonEssential' }) }, { weight: 'bold' })}
                </div>
              </a>
            </div>
          </div>`,
        })}
      </div>
    `;
  }
}
